module.exports = __webpack_public_path__ + "img/home_menu_9_default.0aee74e6.png";